import { useNavigate } from "react-router-dom";
import { FiEdit3 } from "react-icons/fi";

const FloatingEditorialButton = () => {
  const navigate = useNavigate();

  return (
    <button onClick={() => navigate("/editorial/public")} className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-primary text-white shadow-xl flex items-center justify-center hover:scale-110 hover:bg-red-700 transition-all">
      <FiEdit3 size={22} />
    </button>
  );
};

export default FloatingEditorialButton;
